import TextInputField from 'components/Form/TextInputField'
import ModalWrapper from 'components/ModalWrapper'
import React, { useEffect, useState } from 'react'
import { lang } from 'utils/helpers'
import './styles.scss'
import { apiInchat } from 'api'
import inChatRedux from 'redux/inchat/actions'

const ModalCreateSection = ({ isOpenModal, toggleModal, dispatch, conversation={} }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessageModal, setErrorMessageModal] = useState('')
  const [input, setInput] = useState('')

  useEffect(() => {
    if(conversation._id){
      setInput(conversation.name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCreateSection = () => {
    startRequest()
    apiInchat.createSection({
      name: input
    }).then(({ data }) => {
      responseActions(data)
    }).catch(() => setErrorMessageModal(lang('dashboard_error_section_create')))
      .finally(() => setIsLoading(false))
  }

  const handleOpenModal = () => {
    toggleModal()
    setInput('')
    setErrorMessageModal('')
  }

  const startRequest = () => {
    setErrorMessageModal('')
    setIsLoading(true)
  }

  const responseActions = (data, update=false) => {
    if(!data) {
      setErrorMessageModal(lang(update ? 'dashboard_section_exist_name_update' : 'dashboard_section_exist_name'))
      return
    }
    if(data.data.section){
      dispatch(inChatRedux.updateSections(data.data.section))
      handleOpenModal()
    }
  }

  const handleEditSection = () => {
    startRequest()
    apiInchat.updateSectionInfo(conversation._id, {
      name: input
    })
      .then(({ data }) => {
        responseActions(data, true)
      })
      .catch(() => setErrorMessageModal(lang('dashboard_error_update_section')))
      .finally(() => setIsLoading(false))
  }

  return (
    <ModalWrapper
      isOpen={isOpenModal}
      toggle={handleOpenModal}
      header={conversation._id ? lang('dashboard_edit_section') : lang('dashboard_create-section')}
      body={
        <div className='inchat-direct-messages-container__modal-container'>
          <TextInputField
            label={lang('dashboard_name-section')}
            classNameWrapper='text-create-section'
            name={'name_section'}
            value={input}
            onChange={setInput}
          />
        </div>
      }
      eventBtnTxt={conversation._id ? lang('buttons_edit') : lang('dashboard_create')}
      eventBtn={conversation._id ? handleEditSection : handleCreateSection}
      cancelBtnTxt={lang('buttons_cancel')}
      cancelBtn={handleOpenModal}
      isSubmitting={isLoading}
      error={errorMessageModal}
    />
  )
}

export default ModalCreateSection